export default "__VITE_ASSET__1c02c98c__"